var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.333,
    height: 99.333,
    viewBox: "0 0 88.333 99.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_328",
    x: 30.316,
    y: 0,
    width: 27.701,
    height: 38.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_329",
    x: 30.316,
    y: 60.632,
    width: 27.701,
    height: 38.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_330",
    x: 60.632,
    y: 30.316,
    width: 27.701,
    height: 38.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_331",
    x: 0,
    y: 30.316,
    width: 27.701,
    height: 38.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_332",
    x: 23.125,
    y: 12.126,
    width: 42.082,
    height: 41.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_333",
    x: 23.125,
    y: 46.08,
    width: 42.082,
    height: 41.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_334",
    x: 46.08,
    y: 23.04,
    width: 30.126,
    height: 53.253,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_335",
    x: 12.126,
    y: 23.04,
    width: 30.126,
    height: 53.253,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_136",
    "data-name": "Groupe 136",
    transform: "translate(63 96.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_328-2",
    "data-name": "Trac\\xE9 328",
    d: "M105.7-92.079a4.851,4.851,0,0,1-4.851,4.851A4.851,4.851,0,0,1,96-92.079a4.851,4.851,0,0,1,4.851-4.851,4.851,4.851,0,0,1,4.851,4.851Zm0,0",
    transform: "translate(-56.68 96.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_329-2",
    "data-name": "Trac\\xE9 329",
    d: "M105.7,207.921a4.851,4.851,0,1,1-4.851-4.851,4.851,4.851,0,0,1,4.851,4.851Zm0,0",
    transform: "translate(-56.68 -142.44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_330)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_330-2",
    "data-name": "Trac\\xE9 330",
    d: "M255.7,57.921a4.851,4.851,0,1,1-4.851-4.851,4.851,4.851,0,0,1,4.851,4.851Zm0,0",
    transform: "translate(-176.37 -22.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_331-2",
    "data-name": "Trac\\xE9 331",
    d: "M-44.3,57.921a4.851,4.851,0,0,1-4.851,4.851A4.851,4.851,0,0,1-54,57.921a4.851,4.851,0,0,1,4.851-4.851A4.851,4.851,0,0,1-44.3,57.921Zm0,0",
    transform: "translate(63 -22.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_332-2",
    "data-name": "Trac\\xE9 332",
    d: "M80.952-24.8v-1.213a2.425,2.425,0,0,1,2.425-2.425H84.5a9.7,9.7,0,0,0-9.616-8.488H70.038a9.7,9.7,0,0,0-9.616,8.488h1.127a2.425,2.425,0,0,1,2.425,2.425V-24.8Zm0,0",
    transform: "translate(-28.3 49.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_333-2",
    "data-name": "Trac\\xE9 333",
    d: "M80.952,132.283V131.07H63.975v1.213a2.425,2.425,0,0,1-2.425,2.425H60.422a9.7,9.7,0,0,0,9.616,8.488h4.851a9.7,9.7,0,0,0,9.616-8.488H83.377a2.425,2.425,0,0,1-2.425-2.425Zm0,0",
    transform: "translate(-28.3 -84.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_334-2",
    "data-name": "Trac\\xE9 334",
    d: "M176.425,17.07H174V41.323h2.425a9.7,9.7,0,0,0,9.7-9.7V26.771a9.7,9.7,0,0,0-9.7-9.7Zm0,0",
    transform: "translate(-118.92 5.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -63, -96.93)",
    filter: "url(#Trac\\xE9_335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_335-2",
    "data-name": "Trac\\xE9 335",
    d: "M18.126,17.07H15.7a9.7,9.7,0,0,0-9.7,9.7v4.851a9.7,9.7,0,0,0,9.7,9.7h2.425Zm0,0",
    transform: "translate(15.13 5.97)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssoIcon);
export default __webpack_public_path__ + "static/media/asso-icon.fba44117eea36ce4aa3013499454e7f8.svg";
export { ForwardRef as ReactComponent };